import React from 'react';
import { FieldArray } from 'redux-form';

import KeyValueInput from '../../../../Common/Utils/KeyValueInput';

const ParamsTab = (props) => (
  <div style={{ paddingTop: 20 }}>
    <FieldArray name="custom_parameters" baseName="custom_parameters" component={KeyValueInput} keyName="key" mainLabel="Custom Parameters" addItemLabel="Add Parameter" />
  </div>
);

export default ParamsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Rtb/Partials/ParamsTab.tsx